import { render } from "./Add_Section.vue?vue&type=template&id=0ce4250c&scoped=true"
import script from "./Add_Section.vue?vue&type=script&lang=js"
export * from "./Add_Section.vue?vue&type=script&lang=js"

import "./Add_Section.vue?vue&type=style&index=0&id=0ce4250c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce4250c"]])

export default __exports__